import React from 'react';
import PropTypes from 'prop-types';
import {
    FIELD_ERROR_CLASS,
    FIELD_STANDARD_CLASS,
    PWD_INVALID_MSG,
} from '../../../helpers/messageText';

class FieldPassword extends React.Component {
    constructor() {
        super();
        this.state = {
            showPassword: false,
        };
    }

    viewPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    renderClass = valid => {
        if (valid) {
            return FIELD_STANDARD_CLASS;
        } else {
            return FIELD_ERROR_CLASS;
        }
    };

    renderMessage = valid => {
        if (!valid) {
            return <div className="small form-control-feedback">{PWD_INVALID_MSG}</div>;
        }
    };

    render() {
        return (
            <div className={this.renderClass(this.props.fieldState)}>
                <label className="col-2 col-form-label">Password</label>
                <div className="col-sm-10">
                    <div className="input-group">
                        <input
                            ref={input => (this.password = input)}
                            type={this.state.showPassword ? 'text' : 'password'}
                            name="password"
                            value={this.props.defaultValue}
                            onChange={e => this.props.handleChange(e)}
                            className="form-control"
                            placeholder=""
                            autoComplete="foo"
                        />
                        <span
                            className="input-group-addon"
                            onClick={() => {
                                this.viewPassword();
                            }}
                        >
                            <i className="fa fa-eye cursor-pointer" aria-hidden="true" />
                        </span>
                    </div>
                    {this.renderMessage(this.props.fieldState)}
                </div>
            </div>
        );
    }
}

FieldPassword.propTypes = {
    handleChange: PropTypes.func.isRequired,
    fieldState: PropTypes.bool.isRequired,
    defaultValue: PropTypes.string,
};

export default FieldPassword;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/Password.js